export const AUTH_USER = 'AUTH_USER'
export const AUTH_USER_REQUEST = 'AUTH_USER_REQUEST'
export const UNAUTH_USER = 'UNAUTH_USER'
export const AUTH_USER_ERROR = 'AUTH_USER_ERROR'

export const RECAPTCHA_ACTION_LOGIN = 'login';

export const HEADER_RECAPTCHA_TOKEN = "x-recaptcha-token";

export const HEADER_RECAPTCHA_ACTION = "x-recaptcha-action";
